module.exports = __webpack_public_path__ + "img/l2.03343e39.png";